module.exports = __webpack_public_path__ + "img/check.706d922d.svg";